import microservicesIcon from "./assets/microservice.svg";
import insuranceIcon from "./assets/insurance.svg";
import usabilityIcon from "./assets/usability.svg";
import deliveryIcon from "./assets/delivery.svg";
import libraryIcon from "./assets/library.svg";
import hippaIcon from "./assets/HIPAA-compliant-scaled-2 1.svg";

export const features = [
    {
      icon: microservicesIcon,
      title: "Effortless Integration with EHRs",
      description:
        "PDV integrates seamlessly with your existing EHR system, so there's no need to enter the same data twice. Keep your volunteer data accurate and always up-to-date with real-time syncing.",
      bgColor: "#FFD8C4",
      borderColor: "#FFC6AC",
      type: "left",
    },
    {
      icon: libraryIcon,
      title: "Comprehensive Forms Library",
      description:
        "Access the latest collection of customizable forms tailored for every hospice volunteer task. PDV’s library makes it easy to stay organized and compliant with all required documentation.",
      bgColor: "#C6DCBA",
      borderColor: "#C6DCBA",
      type: "right",
    },
    {
      icon: usabilityIcon,
      title: "Mobile Application for Volunteers",
      description:
        "Empower your volunteers with our dedicated mobile app, allowing them to log hours, access forms, receive notifications, and communicate securely—all from the convenience of their mobile devices.",
      bgColor: "#B1AFFF",
      borderColor: "#B1AFFF",
      type: "left",
    },
    {
      icon: deliveryIcon,
      title: "Accurate Volunteer Hour Tracking",
      description:
        "Effortlessly track and log volunteer hours with our simple tracking system. Ensure all records are accurate to meet compliance and regulatory requirements.",
      bgColor: "#ACB1D6",
      borderColor: "#ACB1D6",
      type: "right",
    },
    {
      icon: insuranceIcon,
      title: "Streamlined Documentation & Compliance",
      description:
        "Simplify documentation and ensure compliance with hospice care regulations using our automated workflows. PDV helps reduce administrative burden while meeting industry standards like HIPAA.",
      bgColor: "#F3D0D7",
      borderColor: "#F3D0D7",
      type: "left",
    },
    {
      icon: hippaIcon,
      title: "Efficient, HIPAA-Compliant Communication",
      description:
        "Communicate securely with your hospice volunteers, while maintaining HIPAA compliance. PDV offers integrated messaging solutions that keep everyone connected without compromising on privacy.",
      bgColor: "#7BD3EA",
      borderColor: "#7BD3EA",
      type: "right",
    },
  ];